/* OSO HERO v3, minimal line-art day (linen sky, simplified forest, river, Oso fishing,
   wind/birds/fish) → quick smooth dusk → solid-night sky (half moon, Oso asleep)
   → premium grid. Brand palette + black outlines only. Paper grain, frame arrows. */
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, MotionPathPlugin, DrawSVGPlugin);
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
let _s=20260704; const rng=()=>{_s=(_s*1103515245+12345)&0x7fffffff;return _s/0x7fffffff;};
const rr=(a,b)=>a+(b-a)*rng();

/* ---------- art (minimal line-art, brand palette only) ---------- */
const INK='#000000';
function pineLA(x,base,h,fill){const w=h*0.58;
  return `<g transform="translate(${x} ${base})">`+
    `<rect x="${(-h*0.045).toFixed(1)}" y="-2" width="${(h*0.09).toFixed(1)}" height="${(h*0.13).toFixed(1)}" fill="#563e38" stroke="${INK}" stroke-width="4" stroke-linejoin="round"/>`+
    `<path d="M0 ${-h} L ${(w*0.38).toFixed(1)} ${(-h*0.60).toFixed(1)} L ${(w*0.22).toFixed(1)} ${(-h*0.60).toFixed(1)} L ${(w*0.52).toFixed(1)} ${(-h*0.28).toFixed(1)} L ${(w*0.34).toFixed(1)} ${(-h*0.28).toFixed(1)} L ${(w*0.64).toFixed(1)} 0 L ${(-w*0.64).toFixed(1)} 0 L ${(-w*0.34).toFixed(1)} ${(-h*0.28).toFixed(1)} L ${(-w*0.52).toFixed(1)} ${(-h*0.28).toFixed(1)} L ${(-w*0.22).toFixed(1)} ${(-h*0.60).toFixed(1)} L ${(-w*0.38).toFixed(1)} ${(-h*0.60).toFixed(1)} Z" fill="${fill}" stroke="${INK}" stroke-width="5" stroke-linejoin="round"/></g>`;}
function cloudLA(x,y,s){return `<g class="mcl" data-bx="${x}" data-by="${y}" data-sc="${s}" transform="translate(${x} ${y}) scale(${s})">`+
  `<path d="M-62 18 A17 17 0 0 1 -53 -13 A24 24 0 0 1 -12 -29 A20 20 0 0 1 27 -17 A15 15 0 0 1 51 3 A13 13 0 0 1 45 18 Z" fill="#ffffff" stroke="${INK}" stroke-width="4.5" stroke-linejoin="round"/></g>`;}
// soft, realistic puff clouds (same construction as the About-page sky)
function cloudReal(x,y,w,fill,op){const e=(cx,cy,rx,ry)=>`<ellipse cx="${cx.toFixed(0)}" cy="${cy.toFixed(0)}" rx="${rx.toFixed(0)}" ry="${ry.toFixed(0)}"/>`;
  return `<g class="mcl" data-bx="${x}" data-by="${y}" data-sc="1" transform="translate(${x} ${y})" fill="${fill}" opacity="${op}">`+
    e(0,0,w,w*.52)+e(-w*.72,w*.16,w*.5,w*.34)+e(w*.74,w*.13,w*.56,w*.38)+e(0,w*.26,w*.92,w*.42)+`</g>`;}
// birds, same silhouette + flock behaviour as the About-page sky
function flockLA(sc,op,fill){
  const bird=(dx,dy)=>`<g class="sk-bird" transform="translate(${dx} ${dy})">`+
    `<path d="M0 0 Q6 -7 12 0 Q6 -3.5 0 0Z M0 0 Q-6 -7 -12 0 Q-6 -3.5 0 0Z" fill="${fill}"/></g>`;
  return `<g class="flock" data-sc="${sc}" data-op="${op}" opacity="0"><g transform="scale(${sc})">`+
    bird(0,0)+bird(26,-11)+bird(52,-2)+bird(-26,-8)+bird(20,10)+`</g></g>`;}
function dots(n,maxY){let s='';for(let i=0;i<n;i++){const x=rr(30,1890)|0,y=rr(30,maxY)|0,r=rr(1,2.3);
  s+=`<circle class="nstar" cx="${x}" cy="${y}" r="${r.toFixed(1)}" fill="#eae8df" opacity="${rr(0.3,0.95).toFixed(2)}"/>`;}return s;}
function bearMark(x,y,w,color){const L=window.OSO_LOGO,vb=L.views.bear.split(' ').map(Number),h=w*vb[3]/vb[2];
  return `<svg x="${x}" y="${y}" width="${w}" height="${h}" viewBox="${L.views.bear}" style="overflow:visible">`+
    `<g transform="${L.flip}"><g transform="translate(${L.bear.t[0]} ${L.bear.t[1]})"><path d="${L.bear.d}" fill="${color}"/></g>`+
    `<g transform="translate(${L.eye.t[0]} ${L.eye.t[1]})"><path d="${L.eye.d}" fill="${color}"/></g></g></svg>`;}
/* tee tiles are the client's photographs now, shopTee() lives in oso-products.js */
const teeSVG=(fill,print)=>window.shopTee(fill,print||'bear');

(function build(){
  const s=$('#scene');
  const HZ=792; // horizon
  // sun rays (8, illustrated)
  let rays='';for(let a=0;a<8;a++){const t=a*Math.PI/4,c=Math.cos(t),si=Math.sin(t);
    rays+=`<line x1="${(c*108).toFixed(1)}" y1="${(si*108).toFixed(1)}" x2="${(c*132).toFixed(1)}" y2="${(si*132).toFixed(1)}" stroke="${INK}" stroke-width="5" stroke-linecap="round"/>`;}
  // river waves, [x, y, scale] (scale = depth: small/far near the horizon, large/near at the front)
  const waveField=[[948,842,.5],[976,876,.65],[906,912,.78],[1002,948,.9],[882,984,1],[962,1012,1.08],[1048,1042,1.12],[836,1048,1.05],[924,1066,1.18],[770,1066,1.3],[1080,1072,1.34]];
  const waves=waveField.map(([x,y,sc])=>`<g transform="translate(${x} ${y}) scale(${sc})"><path class="wv" d="M-24 0 q12 -10 24 0 q12 10 24 0" fill="none" stroke="${INK}" stroke-width="4" stroke-linecap="round" opacity="0"/></g>`).join('');
  // grass tufts along the banks
  const tuft=(x,y,s)=>`<g class="tuft" transform="translate(${x} ${y}) scale(${s})" fill="none" stroke="${INK}" stroke-width="3" stroke-linecap="round"><path d="M0 0 q1 -12 5 -15"/><path d="M6 0 q1 -9 6 -12"/><path d="M12 0 q0 -11 -2 -15"/></g>`;
  // sun shimmer on the water, Butter dashes, depth-scaled
  const shim=[[942,838,.5],[972,874,.62],[922,918,.78],[988,960,.88],[934,1008,1],[1000,1052,1.12]]
    .map(([x,y,sc])=>`<line class="shm" x1="${(x-19*sc).toFixed(0)}" y1="${y}" x2="${(x+19*sc).toFixed(0)}" y2="${y}" stroke="#c6c2b9" stroke-width="${(5*sc).toFixed(1)}" stroke-linecap="round" opacity="0"/>`).join('');
  // the Great Bear, a faint ghost of the ACTUAL logo bear, with stars pinned along its silhouette
  const UP=[[2,105],[18,88],[40,62],[58,34],[72,24],[84,36],[100,40],[196,12],[256,26],[306,52],[326,92],[310,130],[270,146],[170,150],[86,148],[26,128]];
  let ursa=`<g opacity=".11">${bearMark(0,-8,336,'#eae8df')}</g>`;
  UP.forEach((p,i)=>{const q=UP[(i+1)%UP.length];ursa+=`<line x1="${p[0]}" y1="${p[1]}" x2="${q[0]}" y2="${q[1]}" stroke="#eae8df" stroke-width="1.4" opacity=".26"/>`;});
  UP.forEach((p,i)=>{const r=i%3===0?3.6:2.7;ursa+=`<circle class="cst" cx="${p[0]}" cy="${p[1]}" r="${r}" fill="#eae8df"/><circle cx="${p[0]}" cy="${p[1]}" r="${(r*2.6).toFixed(1)}" fill="#eae8df" opacity=".12"/>`;});
  ursa+=`<circle class="cst" cx="50" cy="100" r="2.2" fill="#eae8df"/>`;
  ursa+=`<text x="118" y="208" text-anchor="middle" font-family="Funnel Sans" font-size="13" letter-spacing="4" fill="#eae8df" opacity=".45">THE GREAT BEAR</text>`;

  s.innerHTML=`
   <!-- DAY, open linen sky: soft realistic clouds, birds, leaves, wind -->
   <g id="day">
     <g id="cloudsSky">${cloudReal(300,320,150,'#ffffff',.6)+cloudReal(880,285,100,'#d3e2f6',.5)+cloudReal(1420,350,132,'#ffffff',.54)+cloudReal(1730,300,88,'#dbe7f7',.44)+cloudReal(640,470,78,'#ffffff',.42)+cloudReal(1180,545,112,'#ffffff',.34)}</g>
     <g id="birds">${flockLA(1.1,.42,'#6a5b7a')+flockLA(1.7,.6,'#4a3f5e')+flockLA(2.4,.78,'#3a3140')}</g>
   </g>

   <!-- NIGHT, one solid colour, half moon, the Great Bear in stars, comets -->
   <g id="night" opacity="0">
     <rect x="-60" y="-60" width="2040" height="1200" fill="#2f455b"/>
     <g id="nstars">${dots(96,660)}${Array.from({length:9},()=>{const x=rr(80,1840)|0,y=rr(150,560)|0,r=rr(4.5,7);
       return `<path class="nspark" transform="translate(${x} ${y})" d="M0 ${-r} L ${(r*.24).toFixed(1)} ${(-r*.24).toFixed(1)} L ${r} 0 L ${(r*.24).toFixed(1)} ${(r*.24).toFixed(1)} L 0 ${r} L ${(-r*.24).toFixed(1)} ${(r*.24).toFixed(1)} L ${-r} 0 L ${(-r*.24).toFixed(1)} ${(-r*.24).toFixed(1)} Z" fill="#eae8df" opacity=".8"/>`;}).join('')}</g>
     <g id="comets">
       <g class="comet" opacity="0"><line x1="5" y1="0" x2="175" y2="0" stroke="#eae8df" stroke-width="3" stroke-linecap="round" opacity=".65"/><circle r="4.2" fill="#eae8df"/></g>
       <g class="comet" opacity="0"><line x1="5" y1="0" x2="145" y2="0" stroke="#eae8df" stroke-width="2.6" stroke-linecap="round" opacity=".6"/><circle r="3.6" fill="#eae8df"/></g>
     </g>
     <circle id="satellite" r="2.6" fill="#eae8df" opacity="0"/>
   </g>

   <!-- fireflies, only at dusk -->
   <g id="fireflies" opacity="0">${Array.from({length:8},()=>`<circle class="fly" cx="${rr(260,1680)|0}" cy="${rr(680,900)|0}" r="${rr(2,3.2).toFixed(1)}" fill="#c6c2b9" opacity="0"/>`).join('')}</g>`;

  $('#osoWord').innerHTML=buildOsoLogo('word','#000000');

  /* four tees, four different shades, across all three designs */
  const prods=[['Bear Tee','#f0e6d4','Cozy','bear','bear-tee'],['Signature Tee','#28344a','River','word','signature-tee'],
    ['Vibe Tee','#4a2e24','Grizzly','mini','vibe-tee'],['Bear Tee','#141414','Night','bear','bear-tee']];
  $('#grid').innerHTML=prods.map(([n,c,cn,pr,id],i)=>`<a class="pcard" href="/pages/product?id=${id}&c=${c.slice(1)}"><div class="th">${teeSVG(c,pr)}</div>
    <div class="cp"><div class="n">${n}</div><div class="r"><span class="c">${cn}</span><span class="pr">₹1,900</span></div></div></a>`).join('');
})();

/* The night section shows either the old product grid or the photo collage, and the
   hidden one is display:none. Anchoring the bear to #grid meant that once the collage
   took over he was peeking out of a 0x0 box — present in the DOM, never on screen.
   Attach him to whichever is actually rendered. */
if(window.osoPeek){
  const nightHost = document.querySelector('#nightCollage') ? '#nightCollage' : '#grid';
  osoPeek(nightHost,{width:90});
}

/* ---------- ambient (runs at rest) ---------- */
// minimal clouds drift gently across the linen sky
const wrapC=gsap.utils.wrap(-260,2180);
$$('#cloudsSky .mcl').forEach((c,i)=>{const bx=+c.dataset.bx,by=+c.dataset.by,sc=+c.dataset.sc,o={d:0};
  gsap.to(o,{d:'+=2440',duration:110+i*24,ease:'none',repeat:-1,
    onUpdate(){c.setAttribute('transform',`translate(${wrapC(bx+o.d).toFixed(1)} ${by}) scale(${sc})`);}});});
// The three flocks are drawn at opacity 0 and the scroll timeline only ever fades them
// OUT at dusk — the code that brought them in went with the leaves. Bring them back:
// each flock crosses the sky at its own depth, then waits a while before returning.
$$('#birds .flock').forEach((f,i)=>{
  /* bigger and more opaque than the original data-op values, which read as specks in
     a 1920-wide sky, and each flock starts part-way across so one is always up there
     instead of the sky sitting empty between passes */
  const op    = [0.62, 0.78, 0.92][i] ?? 0.7;
  const start = [0.36, 0.14, 0.00][i] ?? 0;
  gsap.set(f, { opacity: op, scale: 1.6, transformOrigin: '50% 50%' });
  const cross = gsap.fromTo(f,
    { x: 1960, y: 215 + i * 84 },
    { x: -300, y: 155 + i * 72, duration: 44 - i * 6, repeat: -1, repeatDelay: 5 + i * 4, ease: 'none' });
  cross.progress(start);
  gsap.to(f.querySelectorAll('.sk-bird path'),
    { scaleY: .42, transformOrigin: '50% 100%', duration: .34 + i * .05, repeat: -1, yoyo: true, ease: 'sine.inOut' });
});
// fireflies blink and wander (they appear at dusk via the scroll timeline)
$$('#fireflies .fly').forEach((f,i)=>{
  gsap.to(f,{opacity:'random(0.15,1)',duration:'random(0.5,1.4)',repeat:-1,yoyo:true,ease:'sine.inOut',delay:i*.33});
  gsap.to(f,{x:'random(-32,32)',y:'random(-26,10)',duration:'random(4,7)',repeat:-1,yoyo:true,ease:'sine.inOut'});});
// one slow satellite crosses the night
(function sat(){
  function orbit(){const y0=rr(150,260),y1=y0+rr(50,110);
    gsap.set('#satellite',{x:-30,y:y0});
    gsap.timeline({onComplete:()=>gsap.delayedCall(rr(9,18),orbit)})
      .to('#satellite',{autoAlpha:.85,duration:1.6},0)
      .to('#satellite',{x:1950,y:y1,duration:42,ease:'none'},0)
      .to('#satellite',{autoAlpha:0,duration:1.6},40.4);}
  gsap.delayedCall(6,orbit);
})();
/* ---------- Oso walks the grassland, back and forth, without stopping ---------- */
(function osoWalk(){
  const w=$('#osoWalker'), sp=$('.walk-sprite'); if(!w||!sp) return;
  const COLS=+sp.dataset.cols, ROWS=+sp.dataset.rows, N=+sp.dataset.frames, FPS=+sp.dataset.fps;
  const FW=sp.clientWidth, FH=sp.clientHeight;                 // display cell = element box
  sp.style.backgroundSize=(COLS*FW)+'px '+(ROWS*FH)+'px';      // sheet scaled to match
  let f=25;                       // start on a both-feet-planted frame, not mid-stride
  const draw=()=>{const i=((f%N)+N)%N|0;
    sp.style.backgroundPosition=(-(i%COLS)*FW)+'px '+(-((i/COLS)|0)*FH)+'px';};
  draw();

  const PAD=18, leftB=()=>PAD, rightB=()=>Math.max(PAD+40,innerWidth-FW-PAD);
  let x=Math.max(PAD,innerWidth*0.06), dir=1;                 // he starts already standing, left side
  gsap.set(w,{x}); sp.style.setProperty('--dir',dir); w.style.setProperty('--z',1);
  if(matchMedia('(prefers-reduced-motion:reduce)').matches) return;


  /* One speed factor drives BOTH the legs and the travel, so the frame rate always matches
     how fast he's actually moving, he eases up to pace and rolls to a stop, never stutters. */
  const gait={s:0};                       // 0 = standing still, 1 = full walking pace
  const STRIDE=34;                        // px/s at full pace, matched to the cycle's stride
  let target=0, state='idle';

  gsap.ticker.add((time,dt)=>{
    const d=Math.min(dt,100)/1000;
    if(gait.s>0.001){
      x=Math.max(leftB(),Math.min(rightB(), x+gait.s*STRIDE*d*dir));
      f+=gait.s*FPS*d;                    // legs advance in proportion to distance covered
      gsap.set(w,{x}); draw();
    }
    if(state==='walking' && (dir>0 ? x>=target : x<=target)) newLeg();
  });

  /* he never stops under the hero copy, otherwise his thought bubble would sit on the text */
  function clearOfCopy(t){
    const tag=$('#dayText .tag'); if(!tag) return t;
    const r=tag.getBoundingClientRect(), c=t+FW/2;
    if(c<r.left-40 || c>r.right+40) return t;
    const goRight=Math.min(rightB(), r.right+40-FW/2), goLeft=Math.max(leftB(), r.left-40-FW/2);
    return dir>0 ? (goRight>t?goRight:goLeft) : (goLeft<t?goLeft:goRight);
  }
  function newLeg(){
    if(dir>0 && x>=rightB()-2) dir=-1;              // reached the right edge, turn around
    else if(dir<0 && x<=leftB()+2) dir=1;
    sp.style.setProperty('--dir',dir);
    state='walking';
    target=clearOfCopy(Math.max(leftB(),Math.min(rightB(), x+dir*rr(150,330))));
    if(Math.abs(target-x)<24){dir*=-1;sp.style.setProperty('--dir',dir);
      target=clearOfCopy(Math.max(leftB(),Math.min(rightB(), x+dir*rr(150,330))));}
    gsap.to(gait,{s:1,duration:.8,ease:'power1.out'});         // straight back up to pace
  }
  gsap.delayedCall(0.5,newLeg);            // sets off almost straight away
  addEventListener('resize',()=>{x=Math.max(leftB(),Math.min(rightB(),x));gsap.set(w,{x});});
})();

/* ---------- mouse parallax, layered depth (x-only where the scrub owns y) ---------- */
if(matchMedia('(pointer:fine)').matches){
  const stage=$('.stage');
  stage.addEventListener('mousemove',e=>{
    const r=stage.getBoundingClientRect();
    const mx=(e.clientX-r.left)/r.width-.5;
    gsap.to('#cloudsSky',{x:mx*-9,duration:.9,ease:'power2',overwrite:'auto'});        // far (y is scrubbed)
    gsap.to('#nstars',{x:mx*-6,duration:.9,ease:'power2',overwrite:'auto'});
  });
  stage.addEventListener('mouseleave',()=>{
    gsap.to('#cloudsSky,#nstars',{x:0,duration:1.1,ease:'power2',overwrite:'auto'});
  });
}

/* ---------- intro (on load) ---------- */
gsap.from(['#dayText .ey','#dayText .word','#dayText .tag','#dayText .btns'],{y:26,autoAlpha:0,duration:.85,stagger:.11,ease:'power3.out',delay:.15});

/* ---------- one scroll: day goes dark and the drop appears (no lingering in between) ---------- */
gsap.set(['#day','#night'],{willChange:'transform,opacity'});
const tl=gsap.timeline({defaults:{ease:'none'},scrollTrigger:{
  trigger:'#hero',start:'top top',end:'bottom bottom',scrub:0.55,
  snap:{snapTo:[0,1],duration:{min:0.28,max:0.6},delay:0.03,ease:'power2.inOut'},  // day or night, never parked mid-way
  onUpdate:self=>{const n=self.progress>0.42;
    if(n!==window.__osoNight){window.__osoNight=n;
      const nav=document.querySelector('.oso-nav'); if(nav) nav.classList.toggle('on-dark',n);}
    /* autoAlpha writes visibility:hidden the moment opacity hits 0. Scrubbing back up,
       the snap tween can kill the reversing tween part-way and leave visibility hidden
       even though opacity has returned to 1 — the day copy then reads as simply gone.
       Back at the top, put visibility back by hand. */
    if(self.progress<0.03){
      gsap.set('#dayText,#dayText .ey,#dayText .tag,#dayText .btns,#osoWord,#cloudsSky,#birds',
               {visibility:'visible'});
    }}
}});

/* 1 · the hero copy clears out */
tl.to('#dayText .ey,#dayText .tag,#dayText .btns',{autoAlpha:0,y:-22,duration:0.10},0.02)
  .to('#osoWord',{scale:0.62,autoAlpha:0,transformOrigin:'50% 50%',duration:0.12},0.04)
  .to('#dayText',{autoAlpha:0,duration:0.05},0.16)
  .to('#cloudsSky,#birds',{autoAlpha:0,duration:0.12},0.05);

/* 2 · the sky darkens straight into night */
tl.fromTo('#night',{opacity:0},{opacity:1,duration:0.22},0.06)
  .to('#day',{autoAlpha:0,duration:0.10},0.20)
  .fromTo('#nstars',{autoAlpha:0},{autoAlpha:1,duration:0.14},0.20)
  .fromTo('#nstars circle',{scale:0,transformOrigin:'50% 50%'},{scale:1,duration:0.10,stagger:{amount:0.14,from:'random'}},0.20)
  .fromTo('#fireflies',{autoAlpha:0},{autoAlpha:1,duration:0.10},0.24);

/* 3 · Oso and his grassland shrink down into the dark, and he keeps walking below */
tl.to('#groundTufts',{autoAlpha:0.35,duration:0.16},0.10);

/* 4 · the drop arrives */
tl.fromTo('#gridWrap',{autoAlpha:0},{autoAlpha:1,duration:0.06},0.26)
  .fromTo('#grid .pcard',{autoAlpha:0,y:80,scale:0.88},{autoAlpha:1,y:0,scale:1,stagger:0.05,duration:0.16,ease:'back.out(1.3)'},0.28);
/* the four collage photographs rise in the same beat the product cards used to,
   one after another so the composition assembles itself. */
if(document.querySelector('#nightCollage .nc-i'))
  tl.fromTo('#nightCollage .nc-i',
    {autoAlpha:0,y:56,scale:.96},
    {autoAlpha:1,y:0,scale:1,duration:0.18,stagger:0.035,ease:'power2.out'},0.28);



/* ---------- The Drop shop (3 designs + 2 tiles + colour carousel) ---------- */
(function shop(){
  if(!$('#pcGrid')||!window.OSO_LOGO) return;
  const SW=window.OSO_COLORS;
  const DES=window.OSO_PRODUCTS;
  const heart='<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.6-7-10a3.8 3.8 0 0 1 7-1.6A3.8 3.8 0 0 1 19 10c0 5.4-7 10-7 10Z"/></svg>';
  const bag='<svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  const sw=(a,d)=>(d?OSO_productColors(d):SW).map(s=>`<button class="sw${s[0]===a?' on':''}" style="--c:${s[0]}" data-c="${s[0]}" data-n="${s[1]}" aria-label="${s[1]}"></button>`).join('');

  $('#pcGrid').innerHTML=DES.map(d=>`<a class="pc" data-print="${d.print}" data-id="${d.id}" href="/pages/product?id=${d.id}">
    <button class="pc-fav" aria-label="Save">${heart}</button>
    <div class="pc-img">${shopTee(d.color,d.print)}<button class="pc-qv" data-qv aria-label="Quick view">Quick view</button></div>
    <div class="pc-body"><div class="pc-swatches">${sw(d.color,d)}</div>
      <div class="pc-name">${d.name} <span class="pc-cn">${d.cn}</span></div>
      <div class="pc-row"><span class="pc-price">₹1,900</span></div>
      <button class="pc-add">${bag} Add to bag</button></div></a>`).join('');
  const syncFavs=()=>document.querySelectorAll('#pcGrid .pc').forEach(c=>{const sw=c.querySelector('.sw.on');
    c.querySelector('.pc-fav').classList.toggle('on',!!window.OSO_STORE&&OSO_STORE.inWishlist(c.dataset.id,sw?sw.dataset.c:null));});
  if(window.OSO_STORE){syncFavs();window.addEventListener('oso:store',syncFavs);}

  /* the Essential Tee grid is the main product grid on this page, so he peeks
     from behind it the same way he does on the shop page */
  if(window.osoPeek) osoPeek('#pcGrid',{width:82});

  $('#featGrid').innerHTML=`
    <div class="feat feat-bundle"><div class="feat-tx"><div class="k">The set</div><h3>Build your three.</h3><div class="feat-save">Save ₹500</div><p>Mix any 3 tees and never think about getting dressed again.</p><span class="feat-cta">Build a set →</span></div>
      <div class="feat-art feat-tees">${shopTee('#f0e6d4','bear')}${shopTee('#4a2e24','word')}${shopTee('#f6cbc7','bear')}</div></div>`;

  $('#shopCar').innerHTML=OSO_VARIANTS().map(v=>`<a class="cc" href="/pages/product?id=${v.p.id}&c=${v.hex.slice(1)}"><div class="cim">${shopTee(v.hex,v.p.print)}</div><div class="cb"><div class="cn">${v.p.name} · ${v.cn}</div><div class="cp2">₹1,900</div></div></a>`).join('');

  // both feature tiles are links into the real pages
  const bset=document.querySelector('.feat-bundle');
  if(bset) bset.addEventListener('click',()=>location.href='/pages/build');


  // interactions: swatch swap · save · add-to-bag
  $('#pcGrid').addEventListener('click',e=>{
    const qb=e.target.closest('[data-qv]');
    if(qb){e.preventDefault();e.stopPropagation();window.osoQuickView&&osoQuickView(qb.closest('.pc').dataset.id);return;}
    const s=e.target.closest('.sw');
    if(s){e.preventDefault();e.stopPropagation();const card=s.closest('.pc');card.querySelectorAll('.sw').forEach(x=>x.classList.toggle('on',x===s));
      card.querySelector('.pc-cn').textContent=s.dataset.n;const img=card.querySelector('.pc-img');
      img.innerHTML=shopTee(s.dataset.c,card.dataset.print);
      gsap.fromTo(img.querySelector('.tee-img'),{scale:1.06,autoAlpha:.3},{scale:1,autoAlpha:1,duration:.4,ease:'power2.out'});return;}
    const f=e.target.closest('.pc-fav');if(f){e.preventDefault();e.stopPropagation();
      const pcd=f.closest('.pc'),sw0=pcd.querySelector('.sw.on');
      const on=window.OSO_STORE?OSO_STORE.toggleWishlist(pcd.dataset.id,sw0?sw0.dataset.c:null):!f.classList.contains('on');
      f.classList.toggle('on',on);gsap.fromTo(f,{scale:.7},{scale:1,duration:.4,ease:'back.out(3)'});return;}
    const a=e.target.closest('.pc-add');if(a&&!a.classList.contains('done')){e.preventDefault();e.stopPropagation();
      const card=a.closest('.pc'),act=card.querySelector('.sw.on');
      if(window.OSO_STORE)OSO_STORE.addToCart(card.dataset.id,act?act.dataset.c:OSO_COLORS[0][0],act?act.dataset.n:'Cozy','M',1);
      const t=a.innerHTML;a.classList.add('done');a.innerHTML='Added ✓';
      gsap.fromTo(a,{scale:.94},{scale:1,duration:.35,ease:'back.out(2)'});setTimeout(()=>{a.classList.remove('done');a.innerHTML=t;},1500);}
  });
  // mouse tilt on each tee
  if(!matchMedia('(pointer:coarse)').matches) gsap.utils.toArray('.pc-img').forEach(img=>{const svg=img.querySelector('.tee-img');
    img.addEventListener('mousemove',e=>{const r=img.getBoundingClientRect();const mx=(e.clientX-r.left)/r.width-.5,my=(e.clientY-r.top)/r.height-.5;
      gsap.to(svg,{rotateY:mx*9,rotateX:-my*9,duration:.4,ease:'power2',transformPerspective:820,overwrite:'auto'});});
    img.addEventListener('mouseleave',()=>gsap.to(svg,{rotateX:0,rotateY:0,duration:.6,ease:'power2',overwrite:'auto'}));});
  // carousel arrows + category pills
  const car=$('#shopCar');
  $('.car-prev').addEventListener('click',()=>car.scrollBy({left:-450,behavior:'smooth'}));
  $('.car-next').addEventListener('click',()=>car.scrollBy({left:450,behavior:'smooth'}));
  /* the tabs used to only paint themselves active and never touch the grid.
     Match on the product name so "All" shows everything and each design filters to itself. */
  gsap.utils.toArray('.shop-tab').forEach(t=>t.addEventListener('click',()=>{
    document.querySelectorAll('.shop-tab').forEach(x=>x.classList.toggle('on',x===t));
    const want=t.textContent.trim().toLowerCase();
    document.querySelectorAll('#pcGrid .pc').forEach(card=>{
      const name=(card.querySelector('.pc-name')?.textContent||'').trim().toLowerCase();
      const show=want==='all'||name.startsWith(want);
      card.style.display=show?'':'none';
    });
  }));
  // scroll reveals
  gsap.set('.pc',{y:44});gsap.set('.feat',{y:30});
  gsap.to('.pc',{opacity:1,y:0,duration:.6,stagger:.12,ease:'power2.out',scrollTrigger:{trigger:'#pcGrid',start:'top 82%',once:true}});
  gsap.to('.feat',{opacity:1,y:0,duration:.6,stagger:.12,ease:'power2.out',scrollTrigger:{trigger:'#featGrid',start:'top 85%',once:true}});
})();

/* ---------- Featured product spotlight (mini-PDP) ---------- */
(function feature(){
  if(!$('#feature')||!window.OSO_LOGO) return;
  const SW=window.OSO_COLORS;
  let cur=OSO_COLORS[0][0];
  const bg=()=>'#e4e1d6';
  $('#ftTee').innerHTML=shopTee(cur,'bear');
  $('#ftSw').innerHTML=SW.map(s=>`<button class="fsw${s[0]===cur?' on':''}" style="--c:${s[0]}" data-c="${s[0]}" data-n="${s[1]}" aria-label="${s[1]}"></button>`).join('');
  const FT=OSO_byPrint('bear');
  /* sizes follow the colourway on show, so a shade that was never cut in XS says so */
  const paintFtSizes=()=>{const ck=OSO_colorKey(cur),pick=OSO_defaultSize(FT.id,ck);
    $('#ftSizes').innerHTML=OSO_sizesFor(FT.id,ck).map(([z,n])=>`<button class="fsz${z===pick?' on':''}${n?'':' oos'}"${n?'':' disabled'}>${z}</button>`).join('');};
  paintFtSizes();

  $('#ftSw').addEventListener('click',e=>{const s=e.target.closest('.fsw');if(!s)return;cur=s.dataset.c;
    document.querySelectorAll('#ftSw .fsw').forEach(x=>x.classList.toggle('on',x===s));
    $('#ftCn').textContent=s.dataset.n;$('#ftTee').innerHTML=shopTee(cur,'bear');
    gsap.fromTo('#ftTee .tee-img',{scale:1.06,autoAlpha:.3},{scale:1,autoAlpha:1,duration:.4,ease:'power2.out'});
    gsap.to('#ftStage',{background:bg(cur),duration:.5});paintFtSizes();});
  $('#ftSizes').addEventListener('click',e=>{const z=e.target.closest('.fsz');if(!z||z.classList.contains('soon'))return;
    document.querySelectorAll('#ftSizes .fsz').forEach(x=>x.classList.toggle('on',x===z));});
  $('#ftAdd').addEventListener('click',()=>{const a=$('#ftAdd');if(a.classList.contains('done'))return;const t=a.innerHTML;
    const z=document.querySelector('#ftSizes .fsz.on'), sw=document.querySelector('#ftSw .fsw.on');
    if(window.OSO_STORE) OSO_STORE.addToCart('bear-tee',cur,sw?sw.dataset.n:'Cozy',z?z.textContent.trim():'M',1);
    a.classList.add('done');a.textContent='Added to bag ✓';gsap.fromTo(a,{scale:.97},{scale:1,duration:.35,ease:'back.out(2)'});
    setTimeout(()=>{a.classList.remove('done');a.innerHTML=t;},1600);});
  $('#ftFav').addEventListener('click',()=>{const on=window.OSO_STORE?OSO_STORE.toggleWishlist('bear-tee',cur):false;
    $('#ftFav').classList.toggle('on',on);gsap.fromTo('#ftFav',{scale:.7},{scale:1,duration:.4,ease:'back.out(3)'});});

  // mouse 3D tilt on the tee
  const stg=$('#ftStage');
  if(!matchMedia('(pointer:coarse)').matches){
    stg.addEventListener('mousemove',e=>{const r=stg.getBoundingClientRect();const px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;
      gsap.to('#ftTee .tee-img',{rotateY:px*10,rotateX:-py*10,duration:.4,ease:'power2',transformPerspective:1000,overwrite:'auto'});});
    stg.addEventListener('mouseleave',()=>gsap.to('#ftTee .tee-img',{rotateX:0,rotateY:0,duration:.6,ease:'power2',overwrite:'auto'}));
  }
  gsap.to('.ft-float.f1',{y:-8,duration:2.4,repeat:-1,yoyo:true,ease:'sine.inOut'});
  gsap.to('.ft-float.f2',{y:8,duration:2.8,repeat:-1,yoyo:true,ease:'sine.inOut'});

  // reveals
  gsap.set('#ftStage',{scale:.95});
  gsap.to('#ftStage',{opacity:1,scale:1,duration:.7,ease:'power2.out',scrollTrigger:{trigger:'#feature',start:'top 74%',once:true}});
  gsap.from('.ft-info > *',{y:26,autoAlpha:0,duration:.6,stagger:.07,ease:'power2.out',scrollTrigger:{trigger:'.ft-info',start:'top 80%',once:true}});
})();

/* ---------- Trust strip + Join the slow club + sticky shop bar ---------- */
(function slowclub(){
  if(!$('#slowclub')) return; const L=window.OSO_LOGO;
  // spinning vinyl (Slow Sunday playlist) with the bear on the label
  if(L){const grooves=[88,80,72,64,56].map(r=>`<circle cx="100" cy="100" r="${r}" fill="none" stroke="#2c2748" stroke-width="1.4"/>`).join('');
    $('#joinArt').innerHTML=`<svg class="vinyl" viewBox="0 0 200 200"><circle cx="100" cy="100" r="96" fill="#161228"/>${grooves}<circle cx="100" cy="100" r="34" fill="#8c8880"/>`+
      `<g transform="translate(100 100) scale(.052) translate(-682.85 -364)"><g transform="${L.flip}"><g transform="translate(${L.bear.t[0]} ${L.bear.t[1]})"><path d="${L.bear.d}" fill="#1c1b38"/></g><g transform="translate(${L.eye.t[0]} ${L.eye.t[1]})"><path d="${L.eye.d}" fill="#1c1b38"/></g></g></g>`+
      `<circle cx="100" cy="100" r="4.5" fill="#161228"/></svg>`;}
  // mini tee for the sticky bar
  if(window.shopTee) $('#ssTee').innerHTML=shopTee('#eae8df','bear');

  // count-ups
  gsap.utils.toArray('#slowclub .ts-c').forEach(el=>{const to=+el.dataset.to,o={v:0};
    gsap.to(o,{v:to,duration:1.4,ease:'power2.out',scrollTrigger:{trigger:'.trust-strip',start:'top 82%',once:true},onUpdate:()=>el.textContent=Math.round(o.v)});});
  gsap.to('.ts-item',{opacity:1,y:0,duration:.6,stagger:.1,ease:'power2.out',scrollTrigger:{trigger:'.trust-strip',start:'top 82%',once:true}});
  gsap.set('.ts-item',{y:18});
  gsap.from('.join-card',{y:36,autoAlpha:0,duration:.7,ease:'power2.out',scrollTrigger:{trigger:'.join-card',start:'top 84%',once:true}});

  // join form → success state
  const form=$('#joinForm');
  form.addEventListener('submit',e=>{e.preventDefault();const ok=document.createElement('div');ok.className='join-ok';
    ok.innerHTML='<svg viewBox="0 0 24 24"><path d="M5 12l4 4 10-10"/></svg>You\'re in, check your inbox for the welcome note.';
    form.replaceWith(ok);gsap.from(ok,{y:12,autoAlpha:0,scale:.96,duration:.5,ease:'back.out(1.8)'});});

  // sticky shop bar, show between the featured product and the join CTA
  const bar=$('#stickyShop'); let dismissed=false;
  $('#ssClose').addEventListener('click',()=>{dismissed=true;bar.classList.remove('show');});
  ScrollTrigger.create({trigger:'#feature',start:'bottom 80%',endTrigger:'#slowclub',end:'top 60%',
    onToggle:self=>{if(!dismissed)bar.classList.toggle('show',self.isActive);}});
})();

/* ---------- frame arrows (checkpoints) ---------- */
const marks=[0,0.30,0.56,1.0]; let idx=0;
const heroLen=()=>$('#hero').offsetHeight-innerHeight;
function goto(i){idx=Math.max(0,Math.min(marks.length-1,i));gsap.to(window,{scrollTo:marks[idx]*heroLen(),duration:1.25,ease:'power2.inOut'});
  $('#fUp').classList.toggle('dim',idx<=0);$('#fDown').classList.toggle('dim',idx>=marks.length-1);}
$('#fDown').addEventListener('click',()=>goto(idx+1));
$('#fUp').addEventListener('click',()=>goto(idx-1));
ScrollTrigger.create({trigger:'#hero',start:'top top',end:'bottom bottom',onUpdate:self=>{
  let p=self.progress;let n=0;for(let i=0;i<marks.length;i++){if(p>=marks[i]-0.04)n=i;}idx=n;
  $('#fUp').classList.toggle('dim',idx<=0);$('#fDown').classList.toggle('dim',idx>=marks.length-1);}});

/* ============ PHASE 2 · MEET OSO (real logo bear, interactive) ============ */
function osoBear(){const L=window.OSO_LOGO,C='#4a2f1c';
  return `<svg class="oso" viewBox="${L.views.bear}" aria-label="Oso the bear">
    <g id="oso-b">
      <g transform="${L.flip}"><g transform="translate(${L.bear.t[0]} ${L.bear.t[1]})"><path d="${L.bear.d}" fill="${C}"/></g></g>
      <g id="oso-eyeC" transform="${L.flip}"><g transform="translate(${L.eye.t[0]} ${L.eye.t[1]})"><path d="${L.eye.d}" fill="${C}"/></g></g>
      <g id="oso-eyeO" opacity="0"><circle id="oso-pupil" cx="552" cy="398" r="8.5" fill="${C}"/><circle cx="548.5" cy="394" r="2.6" fill="#fff"/></g>
      <ellipse class="oso-cheek" cx="604" cy="426" rx="15" ry="8" fill="#edb4b4" opacity="0"/>
      <ellipse class="oso-cheek" cx="512" cy="420" rx="11" ry="6" fill="#edb4b4" opacity="0"/>
    </g>
  </svg>`;}
(function meetOso(){
  const stage=$('#moStage'); if(!stage||!$('#cub')) return;
  $('#cub').innerHTML=osoBear();
  if($('#abLogo'))$('#abLogo').innerHTML=buildOsoLogo('word','#141024');
  if($('#abWm'))$('#abWm').innerHTML=buildOsoLogo('word','#3a2c1a');
  const bear=$('#oso-b'),eyeC=$('#oso-eyeC'),eyeO=$('#oso-eyeO'),pupil=$('#oso-pupil'),cheeks=$$('.oso-cheek'),bubble=$('#moBubble');
  let awake=false,busy=false,idleT;
  gsap.to(bear,{scaleY:1.02,transformOrigin:'50% 100%',duration:2.4,yoyo:true,repeat:-1,ease:'sine.inOut'});
  (function zzz(){if(!awake&&!busy){const z=document.createElement('div');z.className='mo-zzz';z.textContent='z';
      z.style.cssText='left:57%;top:34%;font-size:'+(16+rr(0,10)).toFixed(0)+'px';stage.appendChild(z);
      gsap.to(z,{keyframes:[{opacity:.85,duration:.4},{y:-46,x:24,opacity:0,duration:1.7}],onComplete:()=>z.remove()});}
    gsap.delayedCall(rr(1.5,2.6),zzz);})();
  function say(t,ms){bubble.textContent=t;gsap.fromTo(bubble,{opacity:0,y:8,scale:.9},{opacity:1,y:0,scale:1,duration:.3,ease:'back.out(2)'});
    gsap.to(bubble,{opacity:0,y:-6,duration:.4,delay:(ms||1600)/1000});}
  function wake(){if(awake||busy)return;awake=true;
    gsap.to(eyeC,{opacity:0,duration:.12});gsap.to(eyeO,{opacity:1,duration:.2});
    gsap.to(bear,{y:-8,rotation:-2,transformOrigin:'50% 92%',duration:.4,ease:'back.out(2)'});gsap.to(cheeks,{opacity:.7,duration:.3});}
  function sleep(){if(!awake||busy)return;awake=false;
    gsap.to(eyeO,{opacity:0,duration:.12});gsap.to(eyeC,{opacity:1,duration:.2});
    gsap.to(bear,{y:0,rotation:0,duration:.5});gsap.to(pupil,{x:0,y:0,duration:.3});gsap.to(cheeks,{opacity:0,duration:.3});}
  function resetIdle(){clearTimeout(idleT);idleT=setTimeout(sleep,2600);}
  stage.addEventListener('pointermove',e=>{wake();resetIdle();if(busy)return;
    const r=stage.getBoundingClientRect();
    const dx=gsap.utils.clamp(-1,1,(e.clientX-(r.left+r.width/2))/(r.width*0.5));
    const dy=gsap.utils.clamp(-1,1,(e.clientY-(r.top+r.height*0.45))/(r.height*0.5));
    gsap.to(pupil,{x:dx*5,y:dy*4,duration:.4});gsap.to(bear,{rotation:-2+dx*3,duration:.5});});
  stage.addEventListener('pointerleave',()=>{clearTimeout(idleT);sleep();});
  const ICON={
    coffee:'<svg viewBox="0 0 24 24"><path d="M4.5 8.5h12v5.5a4 4 0 0 1-4 4H8.5a4 4 0 0 1-4-4V8.5Z"/><path d="M16.5 9.6h1.8a2.4 2.4 0 0 1 0 4.8h-1.8"/><path d="M8 3.4c-.6.8.3 1.4-.3 2.3M11.5 3.4c-.6.8.3 1.4-.3 2.3"/></svg>',
    music:'<svg viewBox="0 0 24 24"><circle cx="7" cy="17.4" r="2.4"/><circle cx="17" cy="15.4" r="2.4"/><path d="M9.4 17.4V6.4l7.6-1.6v10.6"/></svg>'};
  function fx(icon,x,y,ry){const f=document.createElement('div');f.className='mo-fx';f.innerHTML=icon;f.style.left=x;f.style.top=y;stage.appendChild(f);
    gsap.fromTo(f,{opacity:0,scale:.4,y:14},{opacity:1,scale:1,y:0,duration:.4,ease:'back.out(2)'});
    gsap.to(f,{opacity:0,y:-34,rotation:ry||0,duration:.9,delay:1.2,onComplete:()=>f.remove()});}
  const acts={
    wake(){if(busy)return;wake();busy=true;gsap.timeline({onComplete:()=>{busy=false;resetIdle();}})
      .to(bear,{y:-18,scaleY:1.06,transformOrigin:'50% 100%',duration:.4,ease:'power2.out'}).to(bear,{y:-8,scaleY:1,duration:.5,ease:'power2.out'});
      say(gsap.utils.random(["morning.","oh, hi.","i'm up, i'm up."]));},
    coffee(){wake();busy=true;fx(ICON.coffee,'36%','50%');say('mmm. slow morning.',1900);
      gsap.timeline({onComplete:()=>{busy=false;resetIdle();}}).to(bear,{y:-7,scaleX:1.03,transformOrigin:'50% 100%',duration:.4}).to(bear,{y:-8,scaleX:1,duration:.5});},
    vinyl(){wake();busy=true;fx(ICON.music,'62%','36%',22);fx(ICON.music,'33%','44%',-22);say('the OSO playlist.',2000);
      gsap.timeline({onComplete:()=>{busy=false;resetIdle();}})
        .to(bear,{rotation:3,transformOrigin:'50% 100%',duration:.4,ease:'sine.inOut'}).to(bear,{rotation:-3,duration:.5,ease:'sine.inOut'}).to(bear,{rotation:3,duration:.5,ease:'sine.inOut'}).to(bear,{rotation:0,duration:.35});},
    nap(){busy=false;sleep();say('shhh.',1500);}
  };
  $$('.prop',stage).forEach(b=>b.addEventListener('click',ev=>{ev.stopPropagation();(acts[b.dataset.p]||function(){})();}));
  // ambient drifting clouds + sparkles in the canvas
  const CLOUD='M18 34 a13 13 0 0 1 3 -25 a16 16 0 0 1 31 -1 a12 12 0 0 1 21 8 a10 10 0 0 1 -5 18 z';
  const SPARK='<svg viewBox="0 0 24 24"><path d="M12 2l2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2Z"/></svg>';
  const canvas=$('#moCanvas');
  if(canvas){
    [['7%','9%',1],['81%','6%',1.25],['3%','64%',.85],['87%','58%',1.1]].forEach(([l,t,s])=>{
      const d=document.createElement('div');d.className='mo-float cloud';d.style.cssText=`left:${l};top:${t};transform:scale(${s})`;
      d.innerHTML=`<svg width="90" height="46" viewBox="0 0 90 46"><path d="${CLOUD}"/></svg>`;canvas.appendChild(d);
      gsap.to(d,{x:'+='+rr(22,44),y:'+='+rr(-8,10),duration:rr(6,10),yoyo:true,repeat:-1,ease:'sine.inOut'});});
    [['20%','23%'],['75%','29%'],['29%','80%'],['67%','80%'],['50%','3%'],['12%','44%']].forEach(([l,t])=>{
      const d=document.createElement('div');d.className='mo-float spark';d.style.cssText=`left:${l};top:${t}`;d.innerHTML=SPARK;canvas.appendChild(d);
      gsap.to(d,{opacity:rr(.3,.9),scale:rr(.7,1.25),transformOrigin:'50% 50%',rotation:rr(-30,30),duration:rr(1.4,2.8),yoyo:true,repeat:-1,ease:'sine.inOut'});});
  }
  // dotted lines from Oso out to each floating card
  function drawLines(){const cv=$('#moCanvas'),svg=$('#moLines'),st=$('#moStage');if(!cv||!svg||!st)return;
    if(innerWidth<960){svg.innerHTML='';return;}
    const W=cv.offsetWidth,H=cv.offsetHeight,scx=W/2,scy=H/2,rx=st.offsetWidth/2*0.94,ry=st.offsetHeight/2*0.94;
    svg.setAttribute('viewBox',`0 0 ${W} ${H}`);let h='';
    $$('.fcard',cv).forEach(c=>{const cx=c.offsetLeft+c.offsetWidth/2,cy=c.offsetTop+c.offsetHeight/2;
      const a=Math.atan2(cy-scy,cx-scx),ex=scx+Math.cos(a)*rx,ey=scy+Math.sin(a)*ry;
      h+=`<line x1="${ex|0}" y1="${ey|0}" x2="${cx|0}" y2="${cy|0}"/><circle cx="${cx|0}" cy="${cy|0}" r="3"/>`;});
    svg.innerHTML=h;}
  let rz;window.addEventListener('resize',()=>{clearTimeout(rz);rz=setTimeout(drawLines,150);});
  const cards=$$('.fcard');

  // 1 · mouse parallax (CSS vars → no conflict with the bob/float)
  const depths=cards.map(()=>rr(14,26)),sec=$('#meet');
  sec.addEventListener('pointermove',e=>{const r=canvas.getBoundingClientRect();
    const dx=gsap.utils.clamp(-1,1,(e.clientX-(r.left+r.width/2))/(r.width/2)),dy=gsap.utils.clamp(-1,1,(e.clientY-(r.top+r.height/2))/(r.height/2));
    cards.forEach((c,i)=>gsap.to(c,{'--px':(-dx*depths[i]).toFixed(1)+'px','--py':(-dy*depths[i]).toFixed(1)+'px',duration:.6,ease:'power2.out'}));
    gsap.to('#moStage',{'--px':(-dx*8).toFixed(1)+'px','--py':(-dy*8).toFixed(1)+'px',duration:.6});
    gsap.to('.mo-glow',{'--px':(-dx*12).toFixed(1)+'px','--py':(-dy*12).toFixed(1)+'px',duration:.6});});
  sec.addEventListener('pointerleave',()=>gsap.to(cards.concat([$('#moStage'),$('.mo-glow')]),{'--px':'0px','--py':'0px',duration:.7}));

  // 2 · count-up numbers
  $$('.count').forEach(el=>{const to=+el.dataset.to,comma=el.dataset.comma;
    ScrollTrigger.create({trigger:el,start:'top 94%',once:true,onEnter(){gsap.to({v:0},{v:to,duration:1.5,ease:'power2.out',
      onUpdate(){const n=Math.round(this.targets()[0].v);el.textContent=comma?n.toLocaleString('en-IN'):n;}});}});});

  // 3 · hovering a fact makes Oso react
  const cmsg=['soft.','from the farm.','built to last.','fits everyone.','worth it.','a whole world.'];
  function cardReact(i){if(busy)return;wake();const tl=gsap.timeline();const K=[
    ()=>tl.to(bear,{y:-6,duration:.3,ease:'sine.out'}).to(bear,{y:-8,duration:.4}),
    ()=>tl.to(bear,{rotation:4,transformOrigin:'50% 100%',duration:.3}).to(bear,{rotation:0,duration:.4}),
    ()=>tl.to(bear,{y:-16,duration:.18}).to(bear,{y:-8,duration:.45,ease:'bounce.out'}),
    ()=>tl.to(bear,{rotation:-4,transformOrigin:'50% 100%',duration:.3}).to(bear,{rotation:0,duration:.4}),
    ()=>tl.to(bear,{y:-13,duration:.2}).to(bear,{y:-8,duration:.4,ease:'back.out(2)'}),
    ()=>tl.to(bear,{rotation:3,transformOrigin:'50% 100%',duration:.3,ease:'sine.inOut'}).to(bear,{rotation:-3,duration:.4}).to(bear,{rotation:0,duration:.3})
  ];(K[i]||K[0])();say(cmsg[i]);resetIdle();}
  cards.forEach((c,i)=>c.addEventListener('pointerenter',()=>cardReact(i)));

  // 4 · day/night pedestal toggle
  const toggle=$('#moToggle');
  if(toggle){let night=false;
    const sun='<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4.5"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.4 1.4M17.6 17.6L19 19M19 5l-1.4 1.4M6.4 17.6L5 19"/></svg>';
    const moon='<svg viewBox="0 0 24 24"><path d="M20.5 14.2A8 8 0 1 1 9.8 3.5 6.4 6.4 0 0 0 20.5 14.2Z"/></svg>';
    toggle.addEventListener('click',ev=>{ev.stopPropagation();night=!night;canvas.classList.toggle('night',night);
      const fill=night?'#efdcb8':'#4a2f1c';$$('#oso-b path').forEach(p=>p.setAttribute('fill',fill));const pu=$('#oso-pupil');if(pu)pu.setAttribute('fill',fill);
      toggle.innerHTML=night?moon:sun;say(night?'cozy.':'bright.');});}

  // reveal cards + lines, then gently bob (bob via CSS var --bob)
  gsap.set('.fcard',{autoAlpha:0});gsap.set('#moLines',{autoAlpha:0});
  ScrollTrigger.create({trigger:'#meet',start:'top 66%',once:true,onEnter(){
    gsap.to('.fcard',{autoAlpha:1,duration:0.6,stagger:0.08,ease:'power2.out'});
    cards.forEach((c,i)=>gsap.fromTo(c,{'--bob':'0px'},{'--bob':'-10px',duration:gsap.utils.random(2.6,3.8),yoyo:true,repeat:-1,ease:'sine.inOut',delay:i*0.25}));
    drawLines();gsap.to('#moLines',{autoAlpha:1,duration:0.9,delay:0.3});
  }});
})();

/* ============ PHASE 3 · THE MATERIAL, scroll-driven traceability map ============ */
(function material(){
  if(!$('#matMap')||!window.OSO_LOGO) return;


  const pop={duration:.06,ease:'back.out(2)'};
  const mp={align:'#routePath',alignOrigin:[.5,.5]};
  const TEE='M8 2.5 L5 5 L2.5 8 L5.5 11 L7 9.8 V20 H17 V9.8 L18.5 11 L21.5 8 L19 5 L16 2.5 C15 4.5 9 4.5 8 2.5 Z';

  // build the REAL OSO bear as the traveller, a coin carrying a little tee
  const L=window.OSO_LOGO, C='#5b3f2a';
  $('#vBearInner').innerHTML=
    '<circle r="39" fill="#ffffff" stroke="#e7d9bd" stroke-width="1.5"/>'+
    '<g transform="translate(0 -48) scale(.5) translate(-12 -12)"><path d="'+TEE+'" fill="#cf6b5c"/></g>'+
    '<g transform="scale(.152) translate(-682.85 -364)"><g transform="'+L.flip+'">'+
    '<g transform="translate('+L.bear.t[0]+' '+L.bear.t[1]+')"><path d="'+L.bear.d+'" fill="'+C+'"/></g>'+
    '<g transform="translate('+L.eye.t[0]+' '+L.eye.t[1]+')"><path d="'+L.eye.d+'" fill="'+C+'"/></g>'+
    '</g></g>';

  // ambient drifting cotton fluff, always in motion, so the scene never feels dead
  const fluffG=$('#fluff');
  for(let i=0;i<9;i++){
    const g=document.createElementNS('http://www.w3.org/2000/svg','g');
    g.setAttribute('class','fluffdot');
    g.innerHTML='<circle cx="0" cy="0" r="7"/><circle cx="6" cy="-3" r="5"/><circle cx="-6" cy="-2" r="5"/><circle cx="3" cy="4" r="4.5"/>';
    fluffG.appendChild(g);
    gsap.set(g,{x:110+((i*173)%980),y:70+((i*127)%470),scale:.5+(i%5)*.16,opacity:0,transformOrigin:'50% 50%'});
    gsap.to(g,{opacity:.3+(i%4)*.12,duration:2,delay:i*.25});
    gsap.to(g,{y:'-=14',duration:3+(i%4),repeat:-1,yoyo:true,ease:'sine.inOut',delay:i*.2});
    gsap.to(g,{x:'+='+(26+(i%3)*22),duration:15+i*2,repeat:-1,yoyo:true,ease:'sine.inOut'});
  }

  // initial states
  gsap.set('.mcard',{scale:.55,autoAlpha:0,transformOrigin:'50% 100%'});
  gsap.set('#rmaskP',{drawSVG:'0%'});
  gsap.set('.fanline',{drawSVG:'0%'});
  gsap.set('#delivDots .deliv-in',{scale:0,autoAlpha:0,transformOrigin:'50% 50%'});
  gsap.set('.mnode-glow, .mnode-ping',{opacity:0});
  gsap.set('#india',{opacity:0});
  gsap.set('#wWarm',{opacity:.05}); gsap.set('#wCool',{opacity:0});
  gsap.set('#vBear',{autoAlpha:0});

  // continuous life: bear bobs, each card floats gently
  gsap.to('#vBearInner',{y:-6,rotation:2.5,duration:.75,repeat:-1,yoyo:true,ease:'sine.inOut',transformOrigin:'50% 50%'});
  gsap.utils.toArray('.mcard-in').forEach((el,i)=>
    gsap.to(el,{y:-7,duration:2.4+i*.35,repeat:-1,yoyo:true,ease:'sine.inOut',delay:i*.4}));

  // mouse parallax, far bg / route+nodes / cards on three planes
  const scene=$('#matScene');
  if(scene && !matchMedia('(pointer:coarse)').matches){
    scene.addEventListener('mousemove',e=>{
      const r=scene.getBoundingClientRect();
      const mx=(e.clientX-r.left)/r.width-.5, my=(e.clientY-r.top)/r.height-.5;
      gsap.to('#matFar',{x:mx*22,y:my*15,duration:.6,ease:'power2',overwrite:'auto'});
      gsap.to('.mcards',{x:mx*-13,y:my*-9,duration:.6,ease:'power2',overwrite:'auto'});
    });
    scene.addEventListener('mouseleave',()=>gsap.to('#matFar, .mcards',{x:0,y:0,duration:.9,ease:'power2',overwrite:'auto'}));
  }

  const tl=gsap.timeline({defaults:{ease:'none'},scrollTrigger:{
    trigger:'#material',start:'top top',end:'bottom bottom',scrub:1.5}});
  const ping=(n,t)=>tl.fromTo(n+' .mnode-ping',{scale:.9,opacity:.55},
    {scale:2.4,opacity:0,duration:.08,ease:'power2.out'},t);

  // Arizona wakes; the bear sets off carrying the cotton
  tl.to('#nA .mnode-glow',{opacity:.26,duration:.04},0.02)
    .fromTo('#cardA',{scale:.55,autoAlpha:0},{scale:1,autoAlpha:1,...pop},0.04)
    .to('#vBear',{autoAlpha:1,duration:.03},0.05)
  // bear travels the whole self-drawing route (TN sits ~66% along it)
    .to('#rmaskP',{drawSVG:'0% 100%',duration:.56},0.05)
    .to('#vBear',{motionPath:{path:'#routePath',start:0,end:1,autoRotate:false,...mp},duration:.56},0.05)
  // weather cools as we cross to India + the landmass rises in
    .to('#wWarm',{opacity:0,duration:.32},0.06)
    .to('#india',{opacity:.09,duration:.18},0.32)
    .fromTo('#wCool',{opacity:0},{opacity:.11,duration:.34},0.36)
  // arrive Tamil Nadu (~0.41)
    .to('#nT .mnode-glow',{opacity:.26,duration:.04},0.40)
    .fromTo('#cardT',{scale:.55,autoAlpha:0},{scale:1,autoAlpha:1,...pop},0.41)
    .to('.mat-progress i:nth-child(1)',{backgroundColor:'#3f9c6a',duration:.02},0.41)
  // arrive Hyderabad (~0.60)
    .to('#nH .mnode-glow',{opacity:.26,duration:.04},0.59)
    .fromTo('#cardH',{scale:.55,autoAlpha:0},{scale:1,autoAlpha:1,...pop},0.60)
    .to('#vBear',{autoAlpha:0,duration:.03},0.63)
    .to('.mat-progress i:nth-child(2)',{backgroundColor:'#5c7fbf',duration:.02},0.60)
  // finished tees ship out across India
    .to('.fanline',{drawSVG:'100%',duration:.15,stagger:.03},0.63)
    .to('#delivDots .deliv-in',{scale:1,autoAlpha:1,duration:.06,stagger:.05,ease:'back.out(2.2)'},0.72)
    .fromTo('#cardD',{scale:.55,autoAlpha:0},{scale:1,autoAlpha:1,...pop},0.88)
    .to('.mat-progress i:nth-child(3)',{backgroundColor:'#cf6b5c',duration:.02},0.90);
  // arrival ring-pings
  ping('#nA',0.05); ping('#nT',0.41); ping('#nH',0.60);
})();

/* ============ PHASE 4 · THE FIT, editorial reveal + callouts ============ */
(function fit(){
  if(!$('#fit')) return;
  // hidden initial states (pins centred via xPercent/yPercent so scale can't offset them)
  gsap.set('.pin',{xPercent:-50,yPercent:-50,scale:0,autoAlpha:0});
  gsap.set('.fit-head .kick, .fit-head h2, .fit-head p',{y:26,autoAlpha:0});
  gsap.set('.fit-co',{x:-18});
  gsap.set('.fit-real',{y:16});
  gsap.set('.size-chip',{y:14});
  gsap.set('.fit-thumb',{y:22,autoAlpha:0});

  const tl=gsap.timeline({scrollTrigger:{trigger:'#fit',start:'top 66%',once:true},defaults:{ease:'power2.out'}});
  tl.to('.fit-head .kick, .fit-head h2, .fit-head p',{y:0,autoAlpha:1,duration:.6,stagger:.08})
  // pins pop on the model and their matching callouts slide in together
    .to('.pin',{scale:1,autoAlpha:1,duration:.42,stagger:.13,ease:'back.out(2.4)'},'-=.15')
    .to('.fit-co',{x:0,autoAlpha:1,duration:.5,stagger:.13},'<')
    .to('.fit-real',{y:0,autoAlpha:1,duration:.5},'-=.15')
    .to('.size-chip',{y:0,autoAlpha:1,duration:.4,stagger:.07,ease:'back.out(2)'},'-=.25')
    .to('.fit-thumb',{y:0,autoAlpha:1,duration:.5,stagger:.1},'-=.3');

  // subtle 3D tilt on the model card (editorial parallax)
  const stage=$('#fitStage');
  if(stage && !matchMedia('(pointer:coarse)').matches){
    stage.addEventListener('mousemove',e=>{
      const r=stage.getBoundingClientRect();
      const mx=(e.clientX-r.left)/r.width-.5, my=(e.clientY-r.top)/r.height-.5;
      gsap.to('.fit-model',{rotateY:mx*6,rotateX:-my*6,x:mx*9,duration:.6,ease:'power2',
        transformPerspective:820,transformOrigin:'50% 50%',overwrite:'auto'});
    });
    stage.addEventListener('mouseleave',()=>gsap.to('.fit-model',{rotateY:0,rotateX:0,x:0,duration:.8,ease:'power2',overwrite:'auto'}));
  }
})();

/* ============ PHASE 5 · METRO CITY, dusk commute scene ============ */
(function metro(){
  if(!$('#city')) return;
  /* "slice" centres the 1440-wide scene, which pushes the OSO billboard (x≈305)
     off a phone screen — anchor to the left edge instead so it stays in frame */
  const city=$('#city'), fitCity=()=>city.setAttribute('preserveAspectRatio',
    innerWidth<=820?'xMinYMid slice':'xMidYMid slice');
  fitCity(); addEventListener('resize',fitCity);
  const NS='http://www.w3.org/2000/svg';
  // seeded RNG so the skyline is stable across reloads
  const rng=s=>()=>{s=(s*9301+49297)%233280;return s/233280;};

  // OSO character inside the train removed per note 9; keep the city billboard only
  if(window.OSO_LOGO){const L=window.OSO_LOGO;
    const P=o=>'<g transform="translate('+o.t[0]+' '+o.t[1]+')"><path d="'+o.d+'" fill="#f2f2f2"/></g>';
    $('#bbOsoLogo').innerHTML='<g transform="scale(.5) translate(-683 -506)"><g transform="'+L.flip+'">'+P(L.o1)+P(L.s)+P(L.o2)+'</g></g>';}

  // build a skyline band into a group
  function skyline(sel,c){
    const g=$(sel), r=rng(c.seed); let x=-30, html='';
    while(x<1470){
      const w=c.minW+r()*(c.maxW-c.minW), h=c.minH+r()*(c.maxH-c.minH), bx=x, by=c.baseY-h;
      html+='<rect x="'+bx.toFixed(0)+'" y="'+by.toFixed(0)+'" width="'+w.toFixed(0)+'" height="'+(h+6).toFixed(0)+'" fill="'+c.fill+'"/>';
      for(let wy=by+13; wy<c.baseY-12; wy+=15)
        for(let wx=bx+9; wx<bx+w-11; wx+=13)
          if(r()<c.win) html+='<rect class="mc-win" x="'+wx.toFixed(0)+'" y="'+wy.toFixed(0)+'" width="6" height="8" rx="1" fill="'+c.wc+'" opacity="'+(.45+r()*.5).toFixed(2)+'"/>';
      x+=w+(c.gap||6);
    }
    g.innerHTML=html;
  }
  // bases descend far→mid→near and overlap onto the dark ground, so the city reads as one grounded mass
  skyline('#farCity',{seed:7,baseY:640,minW:52,maxW:92,minH:70,maxH:150,fill:'#3a3a3a',win:.22,wc:'#e6e6e6',gap:5});
  skyline('#midCity',{seed:23,baseY:742,minW:66,maxW:122,minH:150,maxH:274,fill:'#272727',win:.3,wc:'#d6d6d6',gap:7});
  skyline('#nearCity',{seed:51,baseY:812,minW:98,maxW:162,minH:96,maxH:150,fill:'#161616',win:.2,wc:'#c2c2c2',gap:9});

  // slim viaduct supports (kept sparse so they read as an elevated track, not clutter)
  let pil='';for(let x=120;x<1440;x+=300)pil+='<rect x="'+x+'" y="604" width="16" height="150" fill="#1a1a1a"/>';
  $('#viaduct').insertAdjacentHTML('beforeend',pil);
  let lamp='';for(let x=90;x<1440;x+=200)lamp+='<g><rect x="'+(x-2)+'" y="700" width="4" height="46" fill="#161616"/><circle cx="'+x+'" cy="700" r="7" fill="#b9b5ab"/><circle cx="'+x+'" cy="700" r="16" fill="#b9b5ab" opacity=".2"/></g>';
  $('#mLamps').innerHTML=lamp;

  // dusk clouds + a few faint stars
  // layered, soft-edged night clouds (multi-ellipse, blurred via #cloudBlur)
  const puffC=w=>{const e=(cx,cy,rx,ry)=>'<ellipse cx="'+cx.toFixed(0)+'" cy="'+cy.toFixed(0)+'" rx="'+rx.toFixed(0)+'" ry="'+ry.toFixed(0)+'"/>';
    return e(0,0,w,w*.5)+e(-w*.72,w*.16,w*.5,w*.33)+e(w*.74,w*.13,w*.56,w*.37)+e(0,w*.26,w*.92,w*.4)
         + e(-w*.32,-w*.2,w*.44,w*.34)+e(w*.36,-w*.16,w*.4,w*.3);};
  const cl=$('#mClouds');
  [[180,150,58,'#c9c9c9',.5],[520,104,40,'#b6b6b6',.4],[880,176,68,'#d4d4d4',.46],
   [1240,126,48,'#c0c0c0',.38],[1010,86,32,'#dcdcdc',.34],[380,206,36,'#b2b2b2',.3]].forEach((c,i)=>{
    const g=document.createElementNS(NS,'g');
    g.setAttribute('fill',c[3]); g.innerHTML=puffC(c[2]); cl.appendChild(g);
    gsap.set(g,{x:c[0],y:c[1],opacity:c[4]});
    gsap.to(g,{x:'+='+(150+i*46),duration:74+i*21,repeat:-1,yoyo:true,ease:'sine.inOut'});
    gsap.to(g,{y:'+='+(6+i*2),duration:16+i*4,repeat:-1,yoyo:true,ease:'sine.inOut'});
  });
  const rs=rng(99);let star='';for(let i=0;i<26;i++){const sx=(rs()*1440).toFixed(0),sy=(rs()*250).toFixed(0);star+='<circle class="mc-star" cx="'+sx+'" cy="'+sy+'" r="'+(.8+rs()*1.3).toFixed(1)+'" fill="#fff" opacity="'+(.3+rs()*.5).toFixed(2)+'"/>';}
  $('#mStars').innerHTML=star;

  // window + star twinkle
  const wins=gsap.utils.toArray('.mc-win'), rt=rng(5);
  for(let i=0;i<wins.length;i+=4){const w=wins[i];gsap.to(w,{opacity:.2,duration:1.4+rt()*2.4,repeat:-1,yoyo:true,ease:'sine.inOut',delay:rt()*3});}
  gsap.utils.toArray('.mc-star').forEach((s,i)=>{if(i%2)gsap.to(s,{opacity:.15,duration:1.2+rt()*1.8,repeat:-1,yoyo:true,ease:'sine.inOut',delay:rt()*2});});

  // the metro glides across, endlessly
  /* it used to take 16s to cross, so the train was often simply not there when you
   looked. Faster crossing = it comes round more than twice as often. */
  gsap.fromTo('#train',{x:-460,y:68},{x:1540,y:68,duration:7.5,repeat:-1,ease:'none'});
  // sun breathes
  gsap.to('#mSunGlow',{opacity:.75,duration:4.5,repeat:-1,yoyo:true,ease:'sine.inOut'});
  // build a detailed OSO hot-air balloon (gores, crown, burner, cables, woven basket, banner)
  (function(){
    const ks=[-1,-.75,-.5,-.25,0,.25,.5,.75,1];
    const cols=['#a8a49a','#d9d5cb','#eae8df','#c6c2b9','#8c8880','#c6c2b9','#eae8df','#c6c2b9'];
    const mer=k=>`M0 -82 C ${44*k} -78 ${63*k} -44 ${63*k} -6 C ${63*k} 36 ${30*k} 64 ${16*k} 80`;
    let g='';
    for(let i=0;i<8;i++) g+=`<path d="${mer(ks[i])} L ${16*ks[i+1]} 80 C ${30*ks[i+1]} 64 ${63*ks[i+1]} 36 ${63*ks[i+1]} -6 C ${63*ks[i+1]} -44 ${44*ks[i+1]} -78 0 -82 Z" fill="${cols[i]}"/>`;
    g+='<g stroke="#8c8880" stroke-width="1" fill="none" opacity=".45">';
    ks.forEach(k=>g+=`<path d="${mer(k)}"/>`); g+='</g>';
    g+='<path d="M-63 -6 C -60 22 -46 50 -30 68 M63 -6 C 60 22 46 50 30 68" stroke="#00000018" stroke-width="6" fill="none"/>'; // soft shade
    g+='<ellipse cx="-19" cy="-34" rx="24" ry="40" fill="#fff" opacity=".16"/>'; // highlight
    g+='<ellipse cx="0" cy="-81" rx="12" ry="5" fill="#c9331f"/><ellipse cx="0" cy="-82" rx="5" ry="2.4" fill="#8f2216"/>'; // crown
    g+='<path d="M-16 80 L16 80 L12.5 92 L-12.5 92 Z" fill="#6f5230"/>'; // throat
    g+='<ellipse cx="0" cy="98" rx="9" ry="6" fill="#8c8880" opacity=".9"/><ellipse cx="0" cy="99" rx="4.5" ry="3" fill="#eae8df"/>'; // burner glow
    g+='<g stroke="#6b5433" stroke-width="1.2">';
    [-15,-9,-3,3,9,15].forEach((x,i)=>g+=`<line x1="${x}" y1="90" x2="${-11+i*4.4}" y2="110"/>`); g+='</g>';
    g+='<path d="M-13 110 L13 110 L11.5 131 L-11.5 131 Z" fill="#9a723f"/>'; // basket
    g+='<rect x="-14.5" y="107" width="29" height="6" rx="2.5" fill="#6e4f2b"/>'; // rim
    g+='<g stroke="#5f4526" stroke-width=".9" opacity=".65"><line x1="-12.5" y1="118" x2="12.5" y2="118"/><line x1="-12" y1="125" x2="12" y2="125"/><line x1="-5" y1="111" x2="-6" y2="131"/><line x1="5" y1="111" x2="6" y2="131"/><line x1="0" y1="111" x2="0" y2="131"/></g>';
    g+='<g class="mc-banner"><path d="M-50 141 L50 141 L50 165 L0 176 L-50 165 Z" fill="#1c1b38"/>'+
       '<text x="0" y="158" text-anchor="middle" font-family="Funnel Sans,Arial,sans-serif" font-size="15" font-weight="800" fill="#8c8880" letter-spacing="1">SHOP NOW</text></g>';
    $('#balloon').innerHTML='';  // hot-air balloon removed per brand revision (banned motif)
  })();
  // it drifts across the upper sky (kept right of the copy)
  gsap.set('#balloon',{x:1180,y:150});
  gsap.to('#balloon',{x:560,duration:44,repeat:-1,yoyo:true,ease:'sine.inOut'});
  gsap.to('#balloon',{y:'+=18',duration:3.6,repeat:-1,yoyo:true,ease:'sine.inOut'});
  gsap.to('#balloon',{rotation:2.4,duration:5,repeat:-1,yoyo:true,ease:'sine.inOut'});
  // neon billboards glow/breathe
  gsap.to('#bbOsoLogo, .mc-neon',{opacity:.7,duration:1.9,repeat:-1,yoyo:true,ease:'sine.inOut'});

  // copy reveal on enter
  gsap.from('.metro-copy .kick, .metro-copy h2, .metro-copy p, .mc-tags',{y:28,autoAlpha:0,duration:.8,stagger:.1,ease:'power2.out',
    scrollTrigger:{trigger:'#metro',start:'top 62%',once:true}});
  // gentle scroll parallax on the layers
  const par=(sel,dy)=>gsap.fromTo(sel,{y:0},{y:dy,ease:'none',scrollTrigger:{trigger:'#metro',start:'top bottom',end:'bottom top',scrub:true}});
  par('#farCity',-26); par('#midCity',-14); par('#mSun, #mSunGlow',54); par('#mClouds',-40); par('#nearCity',18);

  // subtle mouse parallax for depth
  const sec=$('#metro');
  if(sec && !matchMedia('(pointer:coarse)').matches){
    sec.addEventListener('mousemove',e=>{const r=sec.getBoundingClientRect();const mx=(e.clientX-r.left)/r.width-.5,my=(e.clientY-r.top)/r.height-.5;
      gsap.to('#farCity, #mSun, #mSunGlow',{x:mx*16,duration:.8,ease:'power2',overwrite:'auto'});
      gsap.to('#midCity',{x:mx*26,duration:.8,ease:'power2',overwrite:'auto'});
      gsap.to('#mClouds',{y:my*10,duration:.8,ease:'power2',overwrite:'auto'});});
  }
})();

/* ============ PHASE 6 · OUR STORY, founder manifesto reveal ============ */
(function story(){
  if(!$('#story')) return;
  if(window.OSO_LOGO && window.buildOsoLogo) $('#storyWm').innerHTML=buildOsoLogo('word','#3a2a12');
  gsap.set('.story-kick, .story-mark, .story-quote .ql, .story-by, .story-lead',{y:24,autoAlpha:0});
  gsap.set('.pillar',{y:32,autoAlpha:0});
  const tl=gsap.timeline({scrollTrigger:{trigger:'#story',start:'top 70%',once:true},defaults:{ease:'power2.out'}});
  tl.to('.story-kick',{y:0,autoAlpha:1,duration:.5})
    .to('.story-mark',{y:0,autoAlpha:1,duration:.5},'-=.3')
    // the quote breathes in, line by line
    .to('.story-quote .ql',{y:0,autoAlpha:1,duration:.75,stagger:.2},'-=.15')
    .to('.story-by',{y:0,autoAlpha:1,duration:.5},'-=.15')
    .to('.story-lead',{y:0,autoAlpha:1,duration:.55},'-=.3')
    .to('.pillar',{y:0,autoAlpha:1,duration:.6,stagger:.14},'-=.05');
})();

/* hero primary CTAs → shop / story */
(function heroCta(){
  const p=document.querySelector('#dayText .btn.p'), s=document.querySelector('#dayText .btn.s');
  if(p) p.addEventListener('click',()=>{const t=document.getElementById('listing');
    t?t.scrollIntoView({behavior:'smooth',block:'start'}):(location.href='/collections/all');});
  if(s) s.addEventListener('click',()=>location.href='/pages/our-story');
})();

/* ---------- Camping Oso section (from the client sketch) ---------- */
(function camp(){
  if(!document.querySelector('.camp')||!window.gsap) return;
  gsap.to('.camp-bear',{scale:1.012,duration:3.4,repeat:-1,yoyo:true,ease:'sine.inOut'});
  gsap.utils.toArray('.camp-ember').forEach((e,i)=>gsap.fromTo(e,
    {y:0,autoAlpha:0},
    {keyframes:[{autoAlpha:.85,duration:.35},{autoAlpha:0,duration:1.35}],y:-52,duration:1.7+i*.25,repeat:-1,ease:'power1.out',delay:i*.42}));
  if(window.ScrollTrigger){
    gsap.from('.camp-tx > *',{y:22,autoAlpha:0,duration:.7,stagger:.09,ease:'power2.out',scrollTrigger:{trigger:'.camp',start:'top 80%',once:true}});
    gsap.from('.camp-art',{y:30,autoAlpha:0,duration:.9,ease:'power2.out',scrollTrigger:{trigger:'.camp',start:'top 82%',once:true}});
  }
})();

ScrollTrigger.refresh();
